import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import tw from "tailwind-styled-components";

const DebugAlertWrapper = tw.div`
p-4
text-yellow-800
bg-yellow-500
`;

const mapStateToProps = (state) => ({
  debugLog: state.debugLog,
});

class DebuggingAlert extends React.Component {
  onDownloadLog = () => {
    const file = new Blob([JSON.stringify(this.props.debugLog)], {
      type: "text/plain",
    });

    const a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = "humans_debug_log.json";
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  };

  render() {
    return (
      <DebugAlertWrapper>
        Debug logging is enabled.
        <span
          className="text-blue-700 hover:text-blue-900 cursor-pointer"
          onClick={this.onDownloadLog}
        >
          Download log
        </span>
      </DebugAlertWrapper>
    );
  }
}

DebuggingAlert.propTypes = {
  debugLog: PropTypes.any,
};

export default connect(mapStateToProps)(DebuggingAlert);
